import type {ComponentType} from "react";
import ClassicTaskDetailsPage from "components/taskdetails-remake/TaskDetails.component";
import TaskDetails from "./TaskDetails.component";
import {isTaskDetailsRedesignEnabled} from "./taskDetails.function";
import type {TaskDetailsProps} from "types/taskDetails";

// the classic page is a connected JS component, typed by nothing, so its props are not checked here
const ClassicTaskDetails = ClassicTaskDetailsPage as ComponentType<any>;

/**
 * The task details page of the history, process and document details. These keep their own master
 * layers, which load the task and handle moving between tasks, and render this in place of the page,
 * so fe-task-details-redesign picks it at render (see TaskDetailsWrapper.component for /task and /tasks):
 * flag on -> the redesigned page, flag off -> the classic one. Both pages take the same props.
 */
export const TaskDetailsPage = (props: TaskDetailsProps) =>
    isTaskDetailsRedesignEnabled() ? <TaskDetails {...props}/> : <ClassicTaskDetails {...props}/>;

export default TaskDetailsPage;
